import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { LEGAL_TITLES } from '@couch/shared';
import { errorMessage } from '../../api/client';
import { ADMIN_SIGNUP_KEY, signupApi } from '../../api/signup';

/** Admin → Open sign-up (doc 64): anyone may create an account — only with all legal pages written. */
export function SignupPanel() {
  const queryClient = useQueryClient();
  const state = useQuery({ queryKey: ADMIN_SIGNUP_KEY, queryFn: signupApi.adminState });
  const toggle = useMutation({
    mutationFn: (open: boolean) => signupApi.setOpen(open),
    onSuccess: (data) => { queryClient.setQueryData(ADMIN_SIGNUP_KEY, data); },
  });
  const open = state.data?.open ?? false;
  const missing = state.data?.missing ?? [];
  return (
    <section className="panel signup-panel" aria-labelledby="signup-title">
      <h2 id="signup-title">Open sign-up</h2>
      <p className="muted">
        When open, anyone can create an account on the sign-in page — no invite needed. They confirm they are 18 or older and
        accept the terms; their gallery keeps 100 MB of previews. Invited accounts are not affected.
      </p>
      {state.data && (
        <p className={open ? 'success' : 'muted'} role="status">{open ? 'Sign-up is open.' : 'Sign-up is closed — only invites.'}</p>
      )}
      {!open && missing.length > 0 && (
        <p className="muted">Write these legal pages first (below): {missing.map((k) => LEGAL_TITLES[k]).join(', ')}.</p>
      )}
      <div className="pod-actions">
        <button type="button" className={open ? 'button-quiet' : undefined} disabled={toggle.isPending || !state.data || (!open && missing.length > 0)}
          onClick={() => { toggle.mutate(!open); }}>
          {open ? 'Close sign-up' : 'Open sign-up'}
        </button>
      </div>
      {[state.error, toggle.error].filter(Boolean).map((e, n) => <p key={n} role="alert" className="form-error">{errorMessage(e)}</p>)}
    </section>
  );
}
